import i18n from '../i18n';
import { Condiment } from './condiment.entity';
import { PrintDevice } from './print-device.entity';

/**
 * 菜品
 */
export type MenuDish = {
    // 所在二级菜单id（调味品为-1）
    slu_id?: number;
    /** 同子类内展示排序权重（与 `PATCH menus/first/index` 的 `slu_priority` 一致） */
    slu_priority?: number;
    // 过敏源
    allergen?: string[];
    // 菜品沽清
    bargain_stype?: number;
    // 折扣分项器
    discount_itemizer?: number | null;
    // 菜品描述
    item_description?: string | null;
    // 同类菜品id
    dmi_slu_id?: number;
    // 菜品id
    item_id?: number;
    // 菜品名称1
    item_name1?: string;
    // 菜品名称2
    item_name2?: string;
    // 菜品是否参与全局限制 1-参与，0-没参与
    not_joining_global_limit?: number;
    // 岗位（大厨，二厨，寿司，出菜口等等, Null/-1代表菜品无需打印或显示）
    print_class?: number;
    // 打印机设备
    print_device?: Array<PrintDevice>;
    // 数量
    quantity?: number;
    // 是否启用 局部规则：菜品数量限制 1-启用，0-关闭
    rule_lnr_enable?: number;
    // 是否在超过限制后，仍然可以添加 1-可以，0-不可以
    rule_lnr_limit_enable?: number;
    // 超过限制后，菜品价格
    rule_lnr_limit_price?: number;
    // 最大点餐数量
    rule_lnr_max_num?: number;
    // 最大点餐数量是否与人数挂钩 1-与，0-否
    rule_lnr_max_num_with_customer?: number;
    //
    service_itemizer?: number | null;
    // 需要输入重量，默认为0
    weight_entry_required?: number | null;
    // 额外菜品备注
    ext_dish_info?: string;
    /** 菜品名称/备注多语言 JSON（与 RBP2 `item_i18n` 一致） */
    item_i18n?: string;
    // 菜品信息图标
    other_detail_info?: string[];
    // 食物缩略图片
    foodImage?: string;
    // 食物大图片
    bigFoodImage?: string;
    /** 菜品静态资源图文件名或 URL（与 `restaurant-static` `dish-image` 对接） */
    dish_image?: string | null;
    // 调味品
    condiments?: Array<Condiment>;
    //  0 普通菜品 1调味品 2时价菜 3套餐 4自定义 5文字 6称重菜品 7计时菜品
    item_type?: number;
    // 已点菜的客户
    customers?: Array<string>;
    // 菜品报告总数量
    familyDishTotalCount?: number;
    // 菜品ID
    origin_id?: string;
    // 同类点餐限制
    category_order_limit?: number;
    // 助记码
    nlu?: string;
    // 忽略KWA点餐餐厅模式显示规则 1 忽略 0不忽略
    rules_ignore_the_display?: number;
    // 税率组
    tax_group?: number;
    // 调味品
    scomdiment_groups_id?: number;
    comdiment_groups_name?: string;
    // 菜品规格 1
    unit_1?: string | null;
    // 单价 1
    price_1?: number;
    // 外卖 自取 打包价格 1
    takeout_price_1?: number;
    // 菜品规格 2
    unit_2?: string | null;
    // 单价 2
    price_2?: number;
    // 外卖 自取 打包价格 2
    takeout_price_2?: number;
    // 菜品规格 3
    unit_3?: string | null;
    // 单价 3
    price_3?: number;
    // 外卖 自取 打包价格 3
    takeout_price_3?: number;
    // 菜品规格 4
    unit_4?: string | null;
    // 单价 4
    price_4?: number;
    // 外卖 自取 打包价格 4
    takeout_price_4?: number;
    // 菜品规格 5
    unit_5?: string | null;
    // 单价 5
    price_5?: number;
    // 外卖 自取 打包价格 5
    takeout_price_5?: number;
    // 特色菜单中使用
    menu_item_id?: number;
    // 特色菜id
    id?: number;
    // 必选调味品
    required_condiment?: number;
    // 自定义报表主类别
    major_group?: number;
    // 自定义报表子类别
    family_group?: number;
    // 基础菜品库菜品所属二级菜单ids(非数据库字段)
    slu_ids?: string;
    // 基础菜品库菜品所属二级菜单id数组(非数据库字段)
    slu_ids_arr?: string[];
    // 基础菜品库菜品关联菜品ids(非数据库字段)
    item_ids?: string;
    // 菜品是否打折 6-打折 3-不打折
    class_id?: number;
    // 所在一级菜单id(非数据库字段)
    main_group_id?: number;
    // 所属小类-大类(非数据库字段)
    belong_menu_name?: string;
    // 单桌限点数量
    rule_table_max_num?: number;
    // 特殊属性 0正常；1厨师推荐（Hot）；2新品推荐 (New) 3打折 (Sale)
    special_attributes?: number;
    /** 计时菜品（item_type=7）：最低时间（分钟） */
    minimum_time?: number;
    /** 展示/业务时长（接口字段，单位依后端约定） */
    menu_time?: number | string | null;
};

// 菜品类型
export const ITEM_TYPE = [
    {
        value: 0,
        label: i18n.t('menu_and_dishes_page_normal_dishes'),
    },
    {
        value: 2,
        label: i18n.t('menu_and_dishes_page_dish_with_current_price'),
    },
    {
        value: 3,
        label: i18n.t('menu_and_dishes_page_set_meal'),
    },
    {
        value: 4,
        label: i18n.t('menu_and_dishes_page_custom'),
    },
    {
        value: 5,
        label: i18n.t('menu_and_dishes_page_text'),
    },
    {
        value: 6,
        label: i18n.t('menu_and_dishes_page_weight_dish'),
    },
    {
        value: 7,
        label: i18n.t('menu_and_dishes_page_timed_dish'),
    },
];
// 菜品规格
export const UNIT = [
    {
        value: 'Btl',
        label: 'Btl',
    },
    {
        value: 'Gls',
        label: 'Gls',
    },
    {
        value: 'Dozen',
        label: 'Dozen',
    },
    {
        value: 'Piece',
        label: 'Piece',
    },
    {
        value: 'Small',
        label: 'Small',
    },
    {
        value: 'Medium',
        label: 'Medium',
    },
    {
        value: 'Large',
        label: 'Large',
    },
];

// 菜品图片 用于图片批量上传页面
export type MenuDishImage = {
    item_name1: string;
    item_name2: string;
    new_item_id: string;
    item_id: number;
    small_image: boolean;
    normal_image: boolean;
    // 是否勾选
    isUpload?: boolean;
}
